import React, { Fragment } from "react";
import { connect } from "react-redux";
import { useProducts } from "../../api";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { addToCart } from "../../store/actions/action";
import ShopProduct from "../../components/ShopProduct";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import ServiceSection from "../../components/ServiceSection/ServiceSection";

const ShopPage = (props) => {
  const { data: products = [], isLoading, error } = useProducts();
  const { t } = useTranslation();
  const { addToCart } = props;

  const addToCartProduct = (product, qty = 1) => {
    addToCart(product, qty, null, null, t);
  };

  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t(`shop`)} pagesub={t(`shop`)} />
      <section className="wpo-shop-page section-padding">
          {/* <ServiceSection /> */}
              <ShopProduct
                addToCartProduct={addToCartProduct}
                products={products}
                isLoading={isLoading}
                error={error}
              />
      </section>
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};


export default connect(null, { addToCart })(ShopPage);